import { ENTITY_TYPE } from 'common/constants/TaxonomyConstants';

import { IExportHeatMapConfig } from './api/type-def';

const { PROCESS, RISK, CONTROL, OBLIGATION } = ENTITY_TYPE;

type COMBINED_MAPPING_TYPE = {
	[key: string]: string;
};

export const EXPORT_COMBINED_COL_MAPPING: COMBINED_MAPPING_TYPE = {
	mappedProcesses: 'Process',
	mappedControls: 'Control',
	mappedRisks: 'Risk',
};

export const EXPORT_MAPPED_OPTION_RISKS = [
	'riskName',
	'riskStatement',
	'riskLevel1',
	'riskLevel2',
	'riskLevel3',
	'displayId',
];

export const EXPORT_MAPPED_OPTION_PROCESSES = [
	'processName',
	'level1',
	'level2',
	'level3',
	'level4',
	'displayId',
];

export const EXPORT_MAPPED_OPTION_CONTROLS = [
	'controlName',
	'controlObjective',
	'displayId',
];

export const EXPORT_COLUMN_OPTIONS_RISKS = [
	{
		label: 'Risk Name',
		value: 'riskName',
	},
	{
		label: 'Risk Statement',
		value: 'riskStatement',
	},
	{
		label: 'Risk Level1',
		value: 'riskLevel1',
	},
	{
		label: 'Risk Level2',
		value: 'riskLevel2',
	},
	{
		label: 'Risk Level3',
		value: 'riskLevel3',
	},
	{
		label: 'Risk Unique ID',
		value: 'displayId',
	},
	{
		label: 'Mapped Processes',
		value: 'mappedProcesses',
		combined: true,
		combinedOptions: EXPORT_MAPPED_OPTION_PROCESSES,
	},
	{
		label: 'Mapped Controls',
		value: 'mappedControls',
		combined: true,
		combinedOptions: EXPORT_MAPPED_OPTION_CONTROLS,
	},
	{
		label: 'Industry',
		value: 'industryType',
	},
	{
		label: 'Last Updated',
		value: 'modifiedDate',
	},
	{
		label: 'Covered Products',
		value: 'products',
	},
];

export const EXPORT_COLUMN_OPTIONS_PROCESSES = [
	{
		label: 'Process Name',
		value: 'processName',
	},
	{
		label: 'Process Level 1',
		value: 'level1',
	},
	{
		label: 'Process Level 2',
		value: 'level2',
	},
	{
		label: 'Process Level 3',
		value: 'level3',
	},
	{
		label: 'Process Level 4',
		value: 'level4',
	},
	{
		label: 'Process Unique ID',
		value: 'displayId',
	},
	{
		label: 'Mapped Risks',
		value: 'mappedRisks',
		combined: true,
		combinedOptions: EXPORT_MAPPED_OPTION_RISKS,
	},
	{
		label: 'Mapped Controls',
		value: 'mappedControls',
		combined: true,
		combinedOptions: EXPORT_MAPPED_OPTION_CONTROLS,
	},
	{
		label: 'Industry',
		value: 'industryType',
	},
	{
		label: 'Last Updated',
		value: 'modifiedDate',
	},
	{
		label: 'Covered Products',
		value: 'products',
	},
];

export const EXPORT_COLUMN_OPTIONS_CONTROLS = [
	{
		label: 'Control Name',
		value: 'controlName',
	},
	{
		label: 'Control Objective',
		value: 'controlObjective',
	},
	{
		label: 'Control Unique ID',
		value: 'displayId',
	},
	{
		label: 'Mapped Processes',
		value: 'mappedProcesses',
		combined: true,
		combinedOptions: EXPORT_MAPPED_OPTION_PROCESSES,
	},
	{
		label: 'Mapped Risks',
		value: 'mappedRisks',
		combined: true,
		combinedOptions: EXPORT_MAPPED_OPTION_RISKS,
	},
	{
		label: 'Frequency',
		value: 'frequency',
	},
	{
		label: 'Key/non-key',
		value: 'keyControl',
	},
	{
		label: 'Type',
		value: 'controlType',
	},
	{
		label: 'Manual or Automated',
		value: 'automatedOrManual',
	},
	{
		label: 'Industry',
		value: 'industryType',
	},
	{
		label: 'Last Updated',
		value: 'modifiedDate',
	},
	{
		label: 'Covered Products',
		value: 'products',
	},
];

export enum EXPORT_NAME {
	TABLE_COLUMN = 'TAXONOMY_EXPORT_COLUMNS',
	HEATMAP_COLUMN = 'TAXONOMY_HEATMAP_EXPORT_COLUMNS',
}

// HEAT MAP CONFIGS
export const EXPORT_TAB_LIST: string[] = [PROCESS, RISK, CONTROL, OBLIGATION];

export const EXPORT_HEAT_MAP_COLUMNS_LIST: any = {
	Process: ['level1', 'level3', 'heatMapScore', 'heatMapScoreChange', 'type'],
	Risk: [
		'riskLevel2',
		'riskLevel3',
		'heatMapScore',
		'heatMapScoreChange',
		'type',
	],
	Control: ['controlName', 'heatMapScore', 'heatMapScoreChange', 'type'],
};

const EXPORT_HEAT_MAP_CONFIG_PROCESS: IExportHeatMapConfig = {
	export: {
		name: 'Process',
		columns: EXPORT_HEAT_MAP_COLUMNS_LIST.Process,
	},
};

const EXPORT_HEAT_MAP_CONFIG_RISK: IExportHeatMapConfig = {
	export: {
		name: 'Risk',
		columns: EXPORT_HEAT_MAP_COLUMNS_LIST.Risk,
	},
};

const EXPORT_HEAT_MAP_CONFIG_CONTROL: IExportHeatMapConfig = {
	export: {
		name: 'Control',
		columns: EXPORT_HEAT_MAP_COLUMNS_LIST.Control,
	},
};

export const EXPORT_HEAT_MAP_BASED_ON_TYPE: Record<
	string,
	IExportHeatMapConfig
> = {
	Control: EXPORT_HEAT_MAP_CONFIG_CONTROL,
	Process: EXPORT_HEAT_MAP_CONFIG_PROCESS,
	Risk: EXPORT_HEAT_MAP_CONFIG_RISK,
};
